<mat-drawer-container autosize>
  <mat-card class="custom-mat-card">
    <mat-card-content class="custom-mat-card-content">
      <div id="container" class="custom-container">
        <div id="header" class="header-title">
          <div id="contentRow" class="custom-header-row">
            <span class="header-title">Customers</span>
            <span class="spacer"></span>
            <div id="status_content" class="status-field">
              <mat-form-field id="status_field" class="dropdown">
                <mat-select
                  id="status_select"
                  placeholder="Status"
                  multiple
                  (selectionChange)="statusSelect($event.value)">
                  @for (stat of statusList; track stat) {
                    <mat-option id="status_options" [value]="stat">
                      {{ stat }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div id="search_div" class="search-field">
              <mat-form-field id="search_field" class="search-input-holder">
                <input
                  id="search_input"
                  placeholder="Search..."
                  matInput
                  class="search-input"
                  autocomplete="off"
                  (keyup)="searchTable($event.target.value)" />
              </mat-form-field>
            </div>
            <div id="export_data" class="export-holder center pointer" (click)="exportData()">
              Export
            </div>
            <button
              id="add_tenant"
              class="add-button"
              mat-button
              [routerLink]="'/customers/' + action.create">
              Customer<i class="fal fa-plus add-button-icon margin-left-10"></i>
            </button>
          </div>
        </div>
        <mat-table
          id="table"
          class="custom-table"
          matSort
          matSortActive="customerName"
          matSortDirection="asc"
          matSortDisableClear
          [dataSource]="sortedData()"
          (matSortChange)="selectSort($event)">
          <ng-container matColumnDef="customerName">
            <mat-header-cell
              id="table_header_name"
              mat-sort-header
              class="name-column"
              *matHeaderCellDef>
              <span class="custom-header pointer" id="customerNameText">Customer</span>
            </mat-header-cell>
            <mat-cell id="nameCell" class="name-column" *matCellDef="let element">
              <span id="nameElement">{{ element.name }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="tenantkey">
            <mat-header-cell
              id="table_header_key"
              mat-sort-header
              class="key-column"
              *matHeaderCellDef>
              <span class="custom-header pointer" id="TenantkText">Key</span>
            </mat-header-cell>
            <mat-cell id="TenantkCell" class="key-column" *matCellDef="let element">
              <span id="TenantkElement">{{ element.tenantKey }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="stack">
            <mat-header-cell
              id="table_header_stack"
              mat-sort-header
              class="stack-column"
              *matHeaderCellDef>
              <span id="stack_text" class="custom-header pointer">Stack</span>
            </mat-header-cell>
            <mat-cell id="stack_cell" class="stack-column" *matCellDef="let element">
              <span id="stack_element">{{ element.stack.name }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="applicationAccess">
            <mat-header-cell id="table_header_applications" class="app-column" *matHeaderCellDef>
              <span class="custom-header" id="satatusText">Applications</span>
            </mat-header-cell>
            <mat-cell id="statusCell" class="app-column" *matCellDef="let element">
              {{ getApplications(element) || '-' }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="integrationsAccess">
            <mat-header-cell
              id="table_header_integrations"
              class="integrations-column"
              *matHeaderCellDef>
              <span class="custom-header" id="integrationsText">Integrations</span>
            </mat-header-cell>
            <mat-cell id="integrationsCell" class="integrations-column" *matCellDef="let element">
              <span
                matTooltip="{{ getIntegrationsHover(element) }}"
                class="truncate"
                matTooltipClass="custom-tooltip"
                [matTooltipShowDelay]="250">
                {{ getIntegrations(element) }}
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="idp">
            <mat-header-cell
              id="table_header_idp"
              class="just-center idp-column"
              mat-sort-header
              *matHeaderCellDef>
              <span class="custom-header pointer" id="satatusText">IDP</span>
            </mat-header-cell>
            <mat-cell id="idp-cell" class="just-center status-column" *matCellDef="let element">
              <div
                class="common-status"
                align="center"
                [ngClass]="{
                  'inactive-status': !element.hasIdentityProvider,
                  'active-status': element.hasIdentityProvider,
                }">
                <span
                  align="center"
                  [ngClass]="{
                    'inactive-status-text': !element.hasIdentityProvider,
                    'active-status-text': element.hasIdentityProvider,
                  }">
                  {{ element.hasIdentityProvider ? active.active : active.inactive }}
                </span>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="status">
            <mat-header-cell
              id="table_header_status"
              class="just-center status-column"
              mat-sort-header
              *matHeaderCellDef>
              <span class="custom-header pointer" id="satatusText">Billing</span>
            </mat-header-cell>
            <mat-cell id="statusCell" class="just-center status-column" *matCellDef="let element">
              <div
                class="common-status"
                align="center"
                [ngClass]="{
                  'inactive-status': element.status === 0,
                  'active-status': element.status === 1,
                  'orange-status': element.status === 2,
                }">
                <span
                  align="center"
                  [ngClass]="{
                    'inactive-status-text': element.status === 0,
                    'active-status-text': element.status === 1,
                    'orange-status-text': element.status === 2,
                  }">
                  {{ CustomerStatus[element.status] }}
                </span>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="edit">
            <mat-header-cell
              id="table_header_edit"
              class="just-center actions-column"
              *matHeaderCellDef>
              <span id="editText" class="custom-header">Actions </span>
            </mat-header-cell>
            <mat-cell id="editCell" class="just-center actions-column" *matCellDef="let element">
              <button
                mat-button
                id="edit_button"
                class="action-button white-button"
                [routerLink]="['/customers', action.edit, element.id]">
                Edit
              </button>
            </mat-cell>
          </ng-container>
          <mat-header-row
            id="tenant_mat_header_row"
            *matHeaderRowDef="displayedColumns; sticky: true">
          </mat-header-row>
          <mat-row id="tenant_mat_row" *matRowDef="let row; columns: displayedColumns"> </mat-row>
        </mat-table>
        @if (resultsLength() > 0) {
          <mat-paginator
            #paginator
            class="custom-mat-paginator"
            [length]="resultsLength()"
            [pageIndex]="pageIndex()"
            [pageSize]="50"
            [pageSizeOptions]="[50, 100, 250]"
            (page)="handlePageEvent($event)">
          </mat-paginator>
        }
        <div class="no-record">
          @if (resultsLength() === 0 && loading() === false && error() === false) {
            <div id="no_data" class="no-data">
              <img
                id="manager_noDataImage"
                src="/assets/images/no_data.svg"
                alt="No Record"
                width="100" />
              <h1 id="manager_noDataText">No Data</h1>
              <p id="manager_noDataContent" class="custom-p">Let's get started shall we?</p>
            </div>
          }
          @if (error() === true) {
            <div id="error_loading" class="no-data">
              <img
                id="manager_error_image"
                src="/assets/images/api_error.svg"
                alt="Error"
                width="100" />
              <h1 id="manager_error_text">Oops!</h1>
              <p id="manager_error_content" class="custom-p">
                We have encountered some trouble retrieving the data!
              </p>
            </div>
          }
          @if (loading()) {
            <app-loading-spinner />
          }
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</mat-drawer-container>
